export default __webpack_public_path__ + "static/media/exchange.22b427af.svg";